import React, { useState, useEffect, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import { notification, Typography } from "antd";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import { createBulkWinner } from "../../../controllers/V1/raffleWinners/raffleWinnersController";
import { Link } from "react-router-dom";
import SkeltonList from "../../../components/SkeltonEffect/list";
import Pagination from "@mui/material/Pagination";
import { faCheckCircle, faDownload, faExclamationCircle, faRefresh } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';
import LoadingEffect from "../../../components/Loading/LoadingEffect";
const UploadWinnerPopup = ({ popUpOpen, togglePopUp }) => {
  const handleCancel = () => {
    togglePopUp();
    setCurrentRows([]);
    setTotalPages(0)

  }
  const fileRef = useRef(null);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();

  const[ jsonData, setJsonData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [start, setStart] = useState(0);
  const [currentRowsData, setCurrentRows] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [countData, setCountData] = useState({});

  const [uploadFile, setUploadFile] = useState({});

  const getFileData = async () => {
    console.log('call getFileData()', uploadFile);
    try {
      if(!uploadFile){
        setJsonData([]);
      } else {
        setIsLoading(true);
        setIsPageLoading(true);
        const fileBuffer = await getFileBuffer(uploadFile);
        const workbook = XLSX.read(fileBuffer, { type: 'buffer' });
        
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        // Convert the sheet to JSON
        const result = XLSX.utils.sheet_to_json(worksheet);        
        console.log('result : ', result);
        setJsonData(result);
      }
    } catch (error) {
      setIsLoading(false);
      setIsPageLoading(false);
    } finally {
      setIsLoading(false);
      setIsPageLoading(false);
    }
  };

  const getFileBuffer = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
  
      reader.onload = () => {
        resolve(reader.result);
      };
  
      reader.onerror = (error) => {
        reject(error);
      };
  
      reader.readAsArrayBuffer(file);
    });
  };

  useEffect(()=>{
    if(uploadFile && (uploadFile?.type === 'text/csv' || uploadFile?.type === 'application/vnd.ms-excel')){
      getFileData();
    } else{
      setCurrentRows([]);
      setTotalPages(0);
    }
  },[uploadFile]);

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);

    const start = (newPage - 1) * rowsPerPage;
    const currentRows = jsonData.slice(start, start + rowsPerPage);

    setStart(start);
    setCurrentRows(currentRows);
  };

  useEffect(()=>{
    handlePageChange('', 1);
  },[jsonData])

  const handleUpload = async () => {
    try {
      setIsPageLoading(true);
      if(uploadFile && jsonData?.length > 0){
        const form = new FormData();
        form.append('file',uploadFile);
        const res = await createBulkWinner(form);
        if(res?.status === true){
          handleCancel();
          notification.open({
            message: "Success",
            description: `${jsonData?.length} winners created..`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
            duration: 2,
          });
        } else {
          notification.open({
            message: "Oops!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
            duration: 2,  
          });
        }
      } else {
        notification.open({
            message: "Oops!",
            description: `Please upload winner file.`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
            duration: 2,
          });
      }
    } catch (error) {
      setIsPageLoading(false); 
    } finally {
      setIsPageLoading(false);
    }
  }

  const onFileChange = (e) =>{
    setIsPageLoading(true);
    try {
      const file = e.target.files[0];
      if(file.type === 'text/csv' || file.type === 'application/vnd.ms-excel'){
        setUploadFile(file);
      } else{
        setIsPageLoading(false);
        setError((pre)=>({
          ...pre,
          file : `File format not supported.`
        }));
        fileRef.current.value = '';
        setUploadFile("");
      }
    } catch (error) {
      console.log('error',error);
    }
    finally {
    }
  }
  const handelReset = ()=>{
    fileRef.current.value = '';
    setUploadFile('');
  }
  return (<>
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Typography variant="h5" component="div" gutterBottom className="inventory_popup_title_heading">
            Lotto Winner's Preview
          </Typography>
          <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>
        <div>
          {/* <div className="inventory_all_tabs">
            <div className="all_tabs_value">
              <label htmlFor="name" className="all_section_for_label_main_class" > Winners Nos. : {`${countData?.totalCount}`}</label>
            </div>

            <div className="all_tabs_value">
              <label htmlFor="name" className="all_section_for_label_main_class" > Straight Amount : {`${countData?.straightPoint}`}</label>
            </div>

            <div className="all_tabs_value">
              <label htmlFor="name" className="all_section_for_label_main_class" > Rumble Amount : {`${countData?.rumblePoint}`}</label>
            </div>

            <div className="all_tabs_value">
              <label htmlFor="name" className="all_section_for_label_main_class" > Chance Amount : {countData?.chancePoint}</label>
            </div>

            <div className="all_tabs_value">
              <label htmlFor="name" className="all_section_for_label_main_class" > Total Amount : {countData?.totalPoint}</label>
            </div>
          </div> */}
          <div className="inventory_all_tabs">
            <div className="all_tabs_value">
              <Link to={`/templates/raffle-winners.xls`} target="__blank" className="form-control store_input_field" style={{textDecoration : 'none'}}><FontAwesomeIcon icon={faDownload} /> Sample</Link>
            </div>
            <div className="fa_filter_rating_review filter_img_and_add_btn_main">
              <input type="file" name="file" id="file" accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={onFileChange} ref={fileRef} className="form-control store_input_field" />
            </div>

            <div className="fa_filter_rating_review filter_img_and_add_btn_main">
              <button type="button" className="form-control store_input_field" onClick={handelReset}>Reset</button>
            </div>
           
            <div className="fa_filter_rating_review filter_img_and_add_btn_main">
            </div>
            
        </div>
        </div>

        <Typography variant="body1" component="div" className="my_delete_popup_paragraph">
          <div className="container-fluid">
            <div className="categories_open_popup_main_contnet">
              <form>
                <div className="form-group row">
                  {/* <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label htmlFor="code" className="all_lable_for_vendor_dashbaord">Search :</label>
                    <input type="text" name="name" id="name" placeholder="Search" className="form-control categories_select_tg_enter_product" />
                  </div> */}

                  <div id="content-wrapper" className="d-flex flex-column">
                    <div className="card shadow mb-4">
                      <div className="card-body pt-0">
                        <div className="table-responsive">
                          <table
                            className="table table-bordered"
                            id="dataTable"
                            width="100%"
                            cellspacing="0"
                          >
                            <thead>
                              <tr>
                                <th>Sl. No.</th>
                                <th>ORDER NO</th>
                                <th>DRAW DATE</th>
                                <th>COUPON CODE</th>
                                <th>TITLE</th>
                                <th>NAME</th>
                                <th>MOBILE</th>
                                <th>PRIZE</th>
                              </tr>
                            </thead>
                            <tbody>
                              {currentRowsData?.length > 0 ? (
                                currentRowsData.map((items, index) => (
                                  <>
                                    <tr key={index}>
                                      <td> {items['Sl.No.']} </td>
                                      <td>{items['ORDER NO']}</td>
                                      <td>{moment(items['DRAW DATE']).format('YYYY-MM-DD')}</td>
                                      <td>{items['COUPON CODE']}</td>
                                      <td>{items['TITLE']}</td>
                                      <td>{items['NAME']}</td>
                                      <td>{items['MOBILE']}</td>
                                      <td>{items['PRIZE']}</td>
                                    </tr>
                                  </>
                                ))
                              ) : isLoading ? <SkeltonList row={5} col={8} /> : <tr> 
                                  <td colspan="8" className="img-center" >No data found !</td> 
                              </tr>}
                            </tbody>
                          </table>
                          {totalPages > 0 && (
                            <div className="table_pagination_sales_order">
                              <Pagination
                                count={parseInt(totalPages)}
                                onChange={handlePageChange}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
  

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="inventory_open_popup_action_btn">
                      <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel}>Cancel</button>
                      <button type="button" className="btn btn-danger" disabled={isLoading} onClick={handleUpload}>Upload</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Typography>
        {error && <div style={{ color: 'red' }}>{error}</div>}
      </div>
    </Dialog>
    <LoadingEffect isLoading={isPageLoading} />
  </>);
};

export default UploadWinnerPopup;
